// 一般ユーザーのルートを定義する
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import BusinessReport from '../pages/user/businessreport/BusinessReport';
import Workingtime from '../pages/common/workingtime/Workingtime';
import BusinessReports from '../pages/user/businessreportlist/BusinessReports';
import UserSidebarLayout from '../components/sidebar/UserSidebarLayout';

const UserRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<UserSidebarLayout />}>
        <Route path="report" element={<BusinessReport />} />
        <Route path="workingtime" element={<Workingtime />} />
        <Route path="reports" element={<BusinessReports />} />
      </Route>
    </Routes>
  );
};

export default UserRoutes;
